module.exports = __webpack_public_path__ + "img/whatapp.703b5e5c.jpg";